import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

export default function ReportUserMenuItem({ onClick }) {
  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon><ReportGmailerrorredIcon /></ListItemIcon>
      <ListItemText>گزارش کاربر</ListItemText>
    </MenuItem>
  );
}
